var map = {
	"./dummy_thumbnail.jpg": 767,
	"./dummy_user.svg": 768,
	"./favicon.ico": 769,
	"./google-calendar.svg": 770,
	"./guidace_character.png": 771,
	"./header.png": 772,
	"./main.png": 773,
	"./navbar_logo.png": 774,
	"./navbar_logo_white.png": 775,
	"./ogp.png": 776,
	"./ovice_logo.svg": 777,
	"./slack-icon.svg": 778,
	"./slack-logo.svg": 779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 766;